import TrendingChart from './trendingChart.component';

export default TrendingChart;